import { cn } from "@/lib/utils";
import logo from "@/assets/logo_white.png";

interface SidebarBrandProps {
  isCollapsed: boolean;
  onNavigateHome: () => void;
}

export const SidebarBrand = ({ isCollapsed, onNavigateHome }: SidebarBrandProps) => {
  return (
    <div
      className={cn(
        "relative flex h-20 items-center border-b border-sidebar-border bg-sidebar/50 backdrop-blur-sm",
        isCollapsed ? "justify-center px-2" : "justify-start px-5",
      )}
    >
      {/* Acento decorativo no rodapé do brand */}
      <span className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent" />

      <div
        className={cn(
          "flex items-center justify-center transition-all duration-300",
          isCollapsed ? "gap-0" : "gap-3",
        )}
      >
        <button
          type="button"
          onClick={onNavigateHome}
          className={cn(
            "group relative grid shrink-0 place-items-center overflow-hidden rounded-xl",
            "h-11 w-11 bg-gradient-to-br from-primary/15 to-primary/5 ring-1 ring-inset ring-primary/20",
            "shadow-sm transition-all duration-200",
            "hover:-translate-y-0.5 hover:shadow-md hover:ring-primary/40 active:translate-y-0 active:scale-95",
            "outline-none focus-visible:ring-2 focus-visible:ring-sidebar-ring",
          )}
          aria-label="Ir para a página inicial"
        >
          <span className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
          <img src={logo} alt="Logo" className="relative h-7 w-7 object-contain" />
        </button>

        <button
          type="button"
          onClick={onNavigateHome}
          className={cn(
            "flex origin-left flex-col items-start overflow-hidden rounded-md outline-none transition-all duration-300",
            "focus-visible:ring-2 focus-visible:ring-sidebar-ring",
            isCollapsed ? "w-0 -translate-x-2 opacity-0" : "w-auto translate-x-0 opacity-100",
          )}
        >
          <div className="flex items-center gap-2">
            <span className="whitespace-nowrap bg-gradient-to-r from-sidebar-foreground to-sidebar-foreground/70 bg-clip-text font-display text-lg font-semibold leading-none tracking-tight text-transparent">
              Workflow
            </span>
            <span className="rounded-md border border-primary/20 bg-primary/10 px-1.5 py-0.5 font-mono text-[10px] font-bold tabular-nums leading-none text-primary">
              {new Date().getFullYear()}
            </span>
          </div>
          <span className="mt-1 whitespace-nowrap text-[10px] font-semibold uppercase tracking-[0.2em] text-sidebar-foreground/50">
            Hub
          </span>
        </button>
      </div>
    </div>
  );
};
